import React from "react";
import { BarChart3, CalendarDays, DollarSign, PieChart , Users} from "lucide-react";

const RevenueDashReport = ({ dailyRevenueList = [], summaryRevenue = {} }) => {
  return (
    <div>
      {/* Summary Section */}
      <div className="card mb-4 shadow-sm">
        <div className="card-header d-flex align-items-center gap-2">
          <BarChart3 className="text-primary" size={20} />
          <h5 className="mb-0">Revenue Summary</h5>
        </div>
        <div className="card-body row">
          <div className="col-md-3">
            <div className="text-muted d-flex align-items-center mb-1">
              <DollarSign size={16} className="me-2" />
              <span>Total Revenue</span>
            </div>
            <h6 className="mb-0">₹{summaryRevenue?.total_revenue || 0}</h6>
          </div>
          <div className="col-md-3">
            <div className="text-muted d-flex align-items-center mb-1">
              <PieChart size={16} className="me-2" />
              <span>ADR</span>
            </div>
            <h6 className="mb-0">₹{summaryRevenue?.average_daily_rate || 0}</h6>
          </div>
          <div className="col-md-3">
            <div className="text-muted d-flex align-items-center mb-1">
              <Users size={16} className="me-2" />
              <span>Total Booked Rooms</span>
            </div>
            <h6 className="mb-0">{summaryRevenue?.total_occupied_rooms || 0}</h6>
          </div>
          <div className="col-md-3">
            <div className="text-muted d-flex align-items-center mb-1">
              <PieChart size={16} className="me-2" />
              <span>Occupancy Rate</span>
            </div>
            <h6 className="mb-0">{summaryRevenue?.occupancy_rate || 0}</h6>
          </div>
        </div>
      </div>

      {/* Daily Revenue List */}
      <div className="card shadow-sm">
        <div className="card-header d-flex align-items-center gap-2">
          <CalendarDays className="text-success" size={20} />
          <h5 className="mb-0">Daily Revenue</h5>
        </div>
        <div className="card-body">
          {dailyRevenueList?.map((item, index) => (
            <div key={index} className="border rounded-3 p-4 mb-3">
              <div className="d-flex justify-content-between">
                <div>
                  <div className="text-muted mb-1">Date</div>
                  <h6 className="mb-0">{item?.date || 'N/A'}</h6>
                </div>
                <div className="text-end">
                  <div className="text-muted mb-1">Total Revenue</div>
                  <h6 className="mb-0">₹{item?.total_revenue || 0}</h6>
                </div>
                <div className="text-end">
                  <div className="text-muted mb-1">Total Bookings</div>
                  <h6 className="mb-0">{item?.total_bookings || 0}</h6>
                </div> 
              </div>
            </div>
          ))}
          {dailyRevenueList.length === 0 && (
            <p className="text-muted text-center mb-0">No data available.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default RevenueDashReport;
